import { cn } from "~/common/cn"
import { AppText } from "~/ui/app-text"

export function Review({
  review,
  avatar,
  position = "left",
}: {
  review: string
  avatar: string
  position?: "left" | "right"
}) {
  return (
    <div
      className={cn(
        "mb-4 flex flex-row items-center",
        position === "right" ? "flex-row-reverse" : ""
      )}
    >
      <div className="flex-shrink-0 self-center">
        <img src={avatar} alt="avatar" className="h-12 w-12 md:h-20 md:w-20" />
      </div>
      <AppText
        variant="body1"
        className={cn(
          "rounded-3xl border-[0.5] border-base-black border-opacity-50 bg-neutral-100 px-6 py-4 shadow-md md:max-w-xl md:text-24",
          position === "left" ? "ml-4 lg:mr-[96px]" : "mr-4 lg:ml-[96px]",
          "self-center-safe"
        )}
      >
        {review}
      </AppText>
    </div>
  )
}
// /* Rectangle 34625569 */

// box-sizing: border-box;

// position: absolute;
// width: 609px;
// height: 105px;
// left: 624px;
// top: 85px;

// background: #F6FAFC;
// border: 0.5px solid rgba(128, 128, 128, 0.55);
// box-shadow: 0px 4px 7px rgba(0, 0, 0, 0.1);
// border-radius: 30px;
